<template>
 <div id="card" :class="[checked?'border-primary u:border':'']"
		class="shadow-sm h-100 border mb-2">
    <p class="mt-1 title">
      <strong>{{ shuttle.serviceType.name }}</strong>
      <span
        v-if="shuttle.serviceType.description"
        v-b-tooltip="{
          title: shuttle.serviceType.description,
          html: true,
          customClass: 'info-popup',
        }"
      >
        <md-icon :icon="'info'" />
      </span>
      <span v-if="shuttle.ratePlanType != 'sc'" v-b-tooltip.hover :title="`Este servicio es de ${shuttle.ratePlanType}`" class="text-info">
        <md-icon :icon="'taxi_alert'" />
      </span>
    </p>
    <b-row>
      <b-col style="width: 45%" class="img-col">
        <img :src="shuttle.serviceType.image" alt />
      </b-col>
      <b-col style="width: 55%">
        <div class="text-right">
          <p v-if="shuttle.serviceType.maxPax > 0" class="p-icon">
            <md-icon  icon="person_outline" /> Hasta {{ shuttle.serviceType.maxPax }}
          </p>
          <p class="p-icon">
            <md-icon v-if="shuttle.serviceType.maxSuitecases > 0 || shuttle.serviceType.suitecasesDescription != ''" icon="luggage" />
            <span v-if="shuttle.serviceType.maxSuitecases > 0">{{shuttle.serviceType.maxSuitecases}}</span>
          </p>
          <span
            v-if="shuttle.serviceType.suitecasesDescription"
            v-b-tooltip="{
              title: shuttle.serviceType.suitecasesDescription,
              html: true,
              customClass: 'info-popup',
            }"
          >
            <md-icon :icon="'info'" />
          </span>
        </div>
        <div v-if="shuttle.meetAndGreet">
          <p class="m-0 text-right">
            <md-icon  icon="sentiment_satisfied" />Meet & greet
          </p>
        </div>
        <p class="m-0 price" v-if="bookInfoPrice > 0 && shuttle.currency.length===3">

          <span
            class="discount-price"
            v-if="bookInfoPriceNoDiscount > bookInfoPrice"
            >${{ bookInfoPriceNoDiscountFormated }}
            <small>{{ shuttle.currency }}</small></span
          ><br />
          <b-button class="select-btn mt-0 mr-1"  @click="onSelectWithOffer" variant="outline-success" size="sm" v-if="showButtons && $hasPermission('reservation.specialRate')">
            <md-icon  icon="mode_edit " />
          </b-button>
          <strong class="text-uppercase price text-primary"
            >${{ bookInfoPriceFormated }}
            <small>{{ shuttle.currency }}</small></strong><br />
          <small>{{ticketLabel}}</small>
        </p>
        <p class="m-0 text-right" v-else>Unavailable</p>
      </b-col>
    </b-row>
    <b-row no-gutters>
      <b-col cols="1">
        <p class="mb-0 text-left" style="">
          <small
            ><strong>Reembolsable</strong></small
          >
        </p>
      </b-col>
      <b-col v-if="showButtons">
        <div class="text-right" v-if="bookInfoPrice > 0">
          <b-button
			:disabled="!$hasPermission('reservation.booking.add')"
			class="select-btn mb-2"
			@click="onSelect" variant="success">
            <span>
              Agregar <md-icon  icon="play_arrow " />
            </span>
          </b-button>
        </div>
      </b-col>
		<b-col v-if="showButtonADDService">
			<div class="d-flex justify-content-end">
				<b-button
					:disabled="!$hasPermission('reservation.booking.add')"
					class="select-btn mb-2 ml-1 d-flex"
					@click="$emit('viewAdditionalServices')" variant="success">
					<span class="text-nowrap"> Agregar servicios adicionales</span> <md-icon  icon="play_arrow " />
				</b-button>
			</div>
		</b-col>
	</b-row>
	<b-row v-if="!$root.isEmpty(shuttle.promotionApplied)">
		<b-col>
			<small><a type="button" @click="onSelectPromotion">Ver promo detalle</a></small>
		</b-col>
	</b-row>
  </div>
</template>

<script>
import MdIcon from '@/components/helpers/MdIcon.vue';
import numeral from 'numeral';
export default {
	components: {
		MdIcon
	},
    props: {
		checked:{type:Boolean,required:false,default:true},
		showButtons:{type:Boolean,required:false,default:true},
		showButtonADDService:{type:Boolean,required:false,default:false},
		shuttle: { type: Object, required: true } ,
		ticket:{type: String,required:true},
    },
    data() {
      return {

      };
    },
    computed: {
      bookInfoPriceFormated() {
        return numeral(this.bookInfoPrice).format('0,0.[00]');
      },
      bookInfoPriceNoDiscountFormated() {
        return numeral(this.bookInfoPriceNoDiscount).format('0,0.[00] ');
      },
      bookInfoPrice() {
        return this.shuttle[this.ticket];
      },
      bookInfoPriceNoDiscount() {
        return this.shuttle[`roundtripNoDiscount`];
      },
      ticketLabel() {
        let label = "";
        switch(this.ticket){
          case "roundtrip":
            label= "Viaje redondo"
            break;
          case "oneway":
            label= "Viaje sencillo"
            break;
        }
        return label

      }
    },
    methods: {
		onSelect() {
			this.$emit('rateSelected',this.shuttle);
		},
		onSelectWithOffer(){
			this.$emit('rateSelectedOffer',this.shuttle);
		},
		onSelectPromotion() {
			this.$emit('tracePromoSelected',this.shuttle.promotionApplied);
		},
    },
  };
</script>

<style>
.info-popup .tooltip-inner {
  text-align: left;
}
</style>
<style scoped>
.discount-price {
  font-size: 16px;
  text-decoration: line-through;
}
.img-col img {
  max-width: 100%;
  max-height: 100px;
}
.img-col {
  text-align: center;
}
.select-btn {
  padding: 0.1rem 1rem;
  margin-top: 0.5rem;
  font-size: 0.9rem;
}
/* .select-icon { */
  /*font-size: 18px;*/
/* } */
.p-icon {
  letter-spacing: -1px;
  margin-bottom: 0;
  font-size: 14px;
  white-space: nowrap;
  display: inline;
  text-align: right;
}
.title {
  font-size: 16px;
  margin-bottom: 0.4rem;
}
#card {
  background-color: #f2f2f2;
  position: relative;
  border-radius: 8px;
  width: 100%;
  /* height: 220px; */
  padding: 0.5rem 16px 0 16px;
}
.be-font-styled {
  /*color: #5636d7;*/
  font-size: 20px !important;
}
.price {
  /* color: #4f39cf; */
  font-size: 20px;
  line-height: 20px;
  text-align: right;
}
.price small {
  font-weight: bold;
  color: #212529 !important;
  font-size: 70%;
}
.price-type {
  font-weight: 100;
  margin-bottom: 0 !important;
}
.u\:border{
	border-width: 0.2rem!important;
	border-radius: 0.5rem;
}
</style>
